import React from 'react';
import { SHADOW_FILTER_ID } from '../constants';
var ShadowFilter = function (_a) {
    var _b = _a.filterId, filterId = _b === void 0 ? SHADOW_FILTER_ID : _b;
    return (React.createElement("filter", { id: filterId, filterUnits: "objectBoundingBox", x: "-50%", y: "-50%", width: "200%", height: "200%" },
        React.createElement("feDropShadow", { dx: "4", dy: "10", stdDeviation: "10", floodColor: "#1D2729", floodOpacity: "0.3" })));
};
export default ShadowFilter;
